import { getBycompanyUuidAndDcUuid, modify } from '@/services/internal/facility/config/RfHotKeyConfig.js';

export default {
    namespace: 'rfHotKeyConfig',

    state: {
        data: {
            list: [],
        },
        showPage: 'query'
    },

    effects: {
        *showPage({ payload }, { call, put }) {
            yield put({
              type: 'onShowPage',
              showPage: payload.showPage,
            });
          },
        *onModify({ payload, callback }, { call, put }) {
            const response = yield call(modify, payload);
            if (callback) callback(response);
        },
        *getBycompanyUuidAndDcUuid({ payload, callback }, { call, put }) {
            const response = yield call(getBycompanyUuidAndDcUuid, payload);
            if (response && response.success) {
                yield put({
                    type: 'save',
                    payload: response.data
                });
            }
        }
    },
    reducers: {
        save(state, action) {
            return {
                ...state,
                data: action.payload,
            };
        },
        onShowPage(state, action) {
            return {
              ...state,
              showPage: action.showPage,
            }
          }
    }
}
